const Project = (global.Project = {
  api: process.env.REACT_APP_BACKEND_URI, // Development API URL
  authApi: process.env.REACT_APP_AUTH_API, // Auth API URL
  // api: 'https://api.defatom.com/', // dev API URL
  // authApi: 'https://console.patchifi.com/', // dev Auth API URL
});
module.exports = Project;
